// @ts-nocheck
/* eslint-disable */
import * as Long from "long";
import { grpc } from "@improbable-eng/grpc-web";
import * as _m0 from "protobufjs/minimal";
import { Empty } from "./google/protobuf/empty";
import { BrowserHeaders } from "browser-headers";
import { OrgUserInvitee } from "./invitation";

export const protobufPackage = "api.v1";

export interface AuthUser {
  id: string;
  login: string;
  full_name: string;
  email: string;
  mobile: string;
  avatar_url: string;
  language: string;
  is_admin: boolean;
  last_login: string;
  created: string;
  short_name: string;
  description: string;
  location: string;
  website: string;
  keep_email_private: boolean;
  keep_activity_private: boolean;
  visibility: string;
  is_organization: boolean;
  can_create_organization: boolean;
  is_local: boolean;
  is_oAuth2: boolean;
  is_active: boolean;
  is_restricted: boolean;
  allow_git_hook: boolean;
  prohibit_login: boolean;
  two_fa_status: boolean;
  login_source: number;
  login_name: string;
  restricted: boolean;
  lower_name: string;
  org_name: string;
  show_guide: boolean;
  onboarding: boolean;
  good_level: number;
  end_time: string;
  max_seats: number;
  invited_org_id: string;
  org_full_name: string;
  invitation_code: string;
  username: string;
  invitations: OrgUserInvitee[];
  avatar: string;
}

function createBaseAuthUser(): AuthUser {
  return {
    id: "",
    login: "",
    full_name: "",
    email: "",
    mobile: "",
    avatar_url: "",
    language: "",
    is_admin: false,
    last_login: "",
    created: "",
    short_name: "",
    description: "",
    location: "",
    website: "",
    keep_email_private: false,
    keep_activity_private: false,
    visibility: "",
    is_organization: false,
    can_create_organization: false,
    is_local: false,
    is_oAuth2: false,
    is_active: false,
    is_restricted: false,
    allow_git_hook: false,
    prohibit_login: false,
    two_fa_status: false,
    login_source: 0,
    login_name: "",
    restricted: false,
    lower_name: "",
    org_name: "",
    show_guide: false,
    onboarding: false,
    good_level: 0,
    end_time: "",
    max_seats: 0,
    invited_org_id: "",
    org_full_name: "",
    invitation_code: "",
    username: "",
    invitations: [],
    avatar: "",
  };
}

export const AuthUser = {
  encode(
    message: AuthUser,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.login !== "") {
      writer.uint32(18).string(message.login);
    }
    if (message.full_name !== "") {
      writer.uint32(26).string(message.full_name);
    }
    if (message.email !== "") {
      writer.uint32(34).string(message.email);
    }
    if (message.mobile !== "") {
      writer.uint32(42).string(message.mobile);
    }
    if (message.avatar_url !== "") {
      writer.uint32(50).string(message.avatar_url);
    }
    if (message.language !== "") {
      writer.uint32(58).string(message.language);
    }
    if (message.is_admin === true) {
      writer.uint32(64).bool(message.is_admin);
    }
    if (message.last_login !== "") {
      writer.uint32(74).string(message.last_login);
    }
    if (message.created !== "") {
      writer.uint32(82).string(message.created);
    }
    if (message.short_name !== "") {
      writer.uint32(90).string(message.short_name);
    }
    if (message.description !== "") {
      writer.uint32(98).string(message.description);
    }
    if (message.location !== "") {
      writer.uint32(106).string(message.location);
    }
    if (message.website !== "") {
      writer.uint32(114).string(message.website);
    }
    if (message.keep_email_private === true) {
      writer.uint32(128).bool(message.keep_email_private);
    }
    if (message.keep_activity_private === true) {
      writer.uint32(136).bool(message.keep_activity_private);
    }
    if (message.visibility !== "") {
      writer.uint32(146).string(message.visibility);
    }
    if (message.is_organization === true) {
      writer.uint32(152).bool(message.is_organization);
    }
    if (message.can_create_organization === true) {
      writer.uint32(160).bool(message.can_create_organization);
    }
    if (message.is_local === true) {
      writer.uint32(168).bool(message.is_local);
    }
    if (message.is_oAuth2 === true) {
      writer.uint32(176).bool(message.is_oAuth2);
    }
    if (message.is_active === true) {
      writer.uint32(184).bool(message.is_active);
    }
    if (message.is_restricted === true) {
      writer.uint32(192).bool(message.is_restricted);
    }
    if (message.allow_git_hook === true) {
      writer.uint32(200).bool(message.allow_git_hook);
    }
    if (message.prohibit_login === true) {
      writer.uint32(208).bool(message.prohibit_login);
    }
    if (message.two_fa_status === true) {
      writer.uint32(216).bool(message.two_fa_status);
    }
    if (message.login_source !== 0) {
      writer.uint32(224).int64(message.login_source);
    }
    if (message.login_name !== "") {
      writer.uint32(234).string(message.login_name);
    }
    if (message.restricted === true) {
      writer.uint32(240).bool(message.restricted);
    }
    if (message.lower_name !== "") {
      writer.uint32(250).string(message.lower_name);
    }
    if (message.org_name !== "") {
      writer.uint32(258).string(message.org_name);
    }
    if (message.show_guide === true) {
      writer.uint32(264).bool(message.show_guide);
    }
    if (message.onboarding === true) {
      writer.uint32(272).bool(message.onboarding);
    }
    if (message.good_level !== 0) {
      writer.uint32(280).int32(message.good_level);
    }
    if (message.end_time !== "") {
      writer.uint32(290).string(message.end_time);
    }
    if (message.max_seats !== 0) {
      writer.uint32(296).int32(message.max_seats);
    }
    if (message.invited_org_id !== "") {
      writer.uint32(306).string(message.invited_org_id);
    }
    if (message.org_full_name !== "") {
      writer.uint32(314).string(message.org_full_name);
    }
    if (message.invitation_code !== "") {
      writer.uint32(322).string(message.invitation_code);
    }
    if (message.username !== "") {
      writer.uint32(330).string(message.username);
    }
    for (const v of message.invitations) {
      OrgUserInvitee.encode(v!, writer.uint32(338).fork()).ldelim();
    }
    if (message.avatar !== "") {
      writer.uint32(346).string(message.avatar);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AuthUser {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.login = reader.string();
          break;
        case 3:
          message.full_name = reader.string();
          break;
        case 4:
          message.email = reader.string();
          break;
        case 5:
          message.mobile = reader.string();
          break;
        case 6:
          message.avatar_url = reader.string();
          break;
        case 7:
          message.language = reader.string();
          break;
        case 8:
          message.is_admin = reader.bool();
          break;
        case 9:
          message.last_login = reader.string();
          break;
        case 10:
          message.created = reader.string();
          break;
        case 11:
          message.short_name = reader.string();
          break;
        case 12:
          message.description = reader.string();
          break;
        case 13:
          message.location = reader.string();
          break;
        case 14:
          message.website = reader.string();
          break;
        case 16:
          message.keep_email_private = reader.bool();
          break;
        case 17:
          message.keep_activity_private = reader.bool();
          break;
        case 18:
          message.visibility = reader.string();
          break;
        case 19:
          message.is_organization = reader.bool();
          break;
        case 20:
          message.can_create_organization = reader.bool();
          break;
        case 21:
          message.is_local = reader.bool();
          break;
        case 22:
          message.is_oAuth2 = reader.bool();
          break;
        case 23:
          message.is_active = reader.bool();
          break;
        case 24:
          message.is_restricted = reader.bool();
          break;
        case 25:
          message.allow_git_hook = reader.bool();
          break;
        case 26:
          message.prohibit_login = reader.bool();
          break;
        case 27:
          message.two_fa_status = reader.bool();
          break;
        case 28:
          message.login_source = longToNumber(reader.int64() as Long);
          break;
        case 29:
          message.login_name = reader.string();
          break;
        case 30:
          message.restricted = reader.bool();
          break;
        case 31:
          message.lower_name = reader.string();
          break;
        case 32:
          message.org_name = reader.string();
          break;
        case 33:
          message.show_guide = reader.bool();
          break;
        case 34:
          message.onboarding = reader.bool();
          break;
        case 35:
          message.good_level = reader.int32();
          break;
        case 36:
          message.end_time = reader.string();
          break;
        case 37:
          message.max_seats = reader.int32();
          break;
        case 38:
          message.invited_org_id = reader.string();
          break;
        case 39:
          message.org_full_name = reader.string();
          break;
        case 40:
          message.invitation_code = reader.string();
          break;
        case 41:
          message.username = reader.string();
          break;
        case 42:
          message.invitations.push(
            OrgUserInvitee.decode(reader, reader.uint32())
          );
          break;
        case 43:
          message.avatar = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AuthUser {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      login: isSet(object.login) ? String(object.login) : "",
      full_name: isSet(object.full_name) ? String(object.full_name) : "",
      email: isSet(object.email) ? String(object.email) : "",
      mobile: isSet(object.mobile) ? String(object.mobile) : "",
      avatar_url: isSet(object.avatar_url) ? String(object.avatar_url) : "",
      language: isSet(object.language) ? String(object.language) : "",
      is_admin: isSet(object.is_admin) ? Boolean(object.is_admin) : false,
      last_login: isSet(object.last_login) ? String(object.last_login) : "",
      created: isSet(object.created) ? String(object.created) : "",
      short_name: isSet(object.short_name) ? String(object.short_name) : "",
      description: isSet(object.description) ? String(object.description) : "",
      location: isSet(object.location) ? String(object.location) : "",
      website: isSet(object.website) ? String(object.website) : "",
      keep_email_private: isSet(object.keep_email_private)
        ? Boolean(object.keep_email_private)
        : false,
      keep_activity_private: isSet(object.keep_activity_private)
        ? Boolean(object.keep_activity_private)
        : false,
      visibility: isSet(object.visibility) ? String(object.visibility) : "",
      is_organization: isSet(object.is_organization)
        ? Boolean(object.is_organization)
        : false,
      can_create_organization: isSet(object.can_create_organization)
        ? Boolean(object.can_create_organization)
        : false,
      is_local: isSet(object.is_local) ? Boolean(object.is_local) : false,
      is_oAuth2: isSet(object.is_oAuth2) ? Boolean(object.is_oAuth2) : false,
      is_active: isSet(object.is_active) ? Boolean(object.is_active) : false,
      is_restricted: isSet(object.is_restricted)
        ? Boolean(object.is_restricted)
        : false,
      allow_git_hook: isSet(object.allow_git_hook)
        ? Boolean(object.allow_git_hook)
        : false,
      prohibit_login: isSet(object.prohibit_login)
        ? Boolean(object.prohibit_login)
        : false,
      two_fa_status: isSet(object.two_fa_status)
        ? Boolean(object.two_fa_status)
        : false,
      login_source: isSet(object.login_source)
        ? Number(object.login_source)
        : 0,
      login_name: isSet(object.login_name) ? String(object.login_name) : "",
      restricted: isSet(object.restricted) ? Boolean(object.restricted) : false,
      lower_name: isSet(object.lower_name) ? String(object.lower_name) : "",
      org_name: isSet(object.org_name) ? String(object.org_name) : "",
      show_guide: isSet(object.show_guide) ? Boolean(object.show_guide) : false,
      onboarding: isSet(object.onboarding) ? Boolean(object.onboarding) : false,
      good_level: isSet(object.good_level) ? Number(object.good_level) : 0,
      end_time: isSet(object.end_time) ? String(object.end_time) : "",
      max_seats: isSet(object.max_seats) ? Number(object.max_seats) : 0,
      invited_org_id: isSet(object.invited_org_id)
        ? String(object.invited_org_id)
        : "",
      org_full_name: isSet(object.org_full_name)
        ? String(object.org_full_name)
        : "",
      invitation_code: isSet(object.invitation_code)
        ? String(object.invitation_code)
        : "",
      username: isSet(object.username) ? String(object.username) : "",
      invitations: Array.isArray(object?.invitations)
        ? object.invitations.map((e: any) => OrgUserInvitee.fromJSON(e))
        : [],
      avatar: isSet(object.avatar) ? String(object.avatar) : "",
    };
  },

  toJSON(message: AuthUser): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.login !== undefined && (obj.login = message.login);
    message.full_name !== undefined && (obj.full_name = message.full_name);
    message.email !== undefined && (obj.email = message.email);
    message.mobile !== undefined && (obj.mobile = message.mobile);
    message.avatar_url !== undefined && (obj.avatar_url = message.avatar_url);
    message.language !== undefined && (obj.language = message.language);
    message.is_admin !== undefined && (obj.is_admin = message.is_admin);
    message.last_login !== undefined && (obj.last_login = message.last_login);
    message.created !== undefined && (obj.created = message.created);
    message.short_name !== undefined && (obj.short_name = message.short_name);
    message.description !== undefined &&
      (obj.description = message.description);
    message.location !== undefined && (obj.location = message.location);
    message.website !== undefined && (obj.website = message.website);
    message.keep_email_private !== undefined &&
      (obj.keep_email_private = message.keep_email_private);
    message.keep_activity_private !== undefined &&
      (obj.keep_activity_private = message.keep_activity_private);
    message.visibility !== undefined && (obj.visibility = message.visibility);
    message.is_organization !== undefined &&
      (obj.is_organization = message.is_organization);
    message.can_create_organization !== undefined &&
      (obj.can_create_organization = message.can_create_organization);
    message.is_local !== undefined && (obj.is_local = message.is_local);
    message.is_oAuth2 !== undefined && (obj.is_oAuth2 = message.is_oAuth2);
    message.is_active !== undefined && (obj.is_active = message.is_active);
    message.is_restricted !== undefined &&
      (obj.is_restricted = message.is_restricted);
    message.allow_git_hook !== undefined &&
      (obj.allow_git_hook = message.allow_git_hook);
    message.prohibit_login !== undefined &&
      (obj.prohibit_login = message.prohibit_login);
    message.two_fa_status !== undefined &&
      (obj.two_fa_status = message.two_fa_status);
    message.login_source !== undefined &&
      (obj.login_source = Math.round(message.login_source));
    message.login_name !== undefined && (obj.login_name = message.login_name);
    message.restricted !== undefined && (obj.restricted = message.restricted);
    message.lower_name !== undefined && (obj.lower_name = message.lower_name);
    message.org_name !== undefined && (obj.org_name = message.org_name);
    message.show_guide !== undefined && (obj.show_guide = message.show_guide);
    message.onboarding !== undefined && (obj.onboarding = message.onboarding);
    message.good_level !== undefined &&
      (obj.good_level = Math.round(message.good_level));
    message.end_time !== undefined && (obj.end_time = message.end_time);
    message.max_seats !== undefined &&
      (obj.max_seats = Math.round(message.max_seats));
    message.invited_org_id !== undefined &&
      (obj.invited_org_id = message.invited_org_id);
    message.org_full_name !== undefined &&
      (obj.org_full_name = message.org_full_name);
    message.invitation_code !== undefined &&
      (obj.invitation_code = message.invitation_code);
    message.username !== undefined && (obj.username = message.username);
    if (message.invitations) {
      obj.invitations = message.invitations.map((e) =>
        e ? OrgUserInvitee.toJSON(e) : undefined
      );
    } else {
      obj.invitations = [];
    }
    message.avatar !== undefined && (obj.avatar = message.avatar);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<AuthUser>, I>>(object: I): AuthUser {
    const message = createBaseAuthUser();
    message.id = object.id ?? "";
    message.login = object.login ?? "";
    message.full_name = object.full_name ?? "";
    message.email = object.email ?? "";
    message.mobile = object.mobile ?? "";
    message.avatar_url = object.avatar_url ?? "";
    message.language = object.language ?? "";
    message.is_admin = object.is_admin ?? false;
    message.last_login = object.last_login ?? "";
    message.created = object.created ?? "";
    message.short_name = object.short_name ?? "";
    message.description = object.description ?? "";
    message.location = object.location ?? "";
    message.website = object.website ?? "";
    message.keep_email_private = object.keep_email_private ?? false;
    message.keep_activity_private = object.keep_activity_private ?? false;
    message.visibility = object.visibility ?? "";
    message.is_organization = object.is_organization ?? false;
    message.can_create_organization = object.can_create_organization ?? false;
    message.is_local = object.is_local ?? false;
    message.is_oAuth2 = object.is_oAuth2 ?? false;
    message.is_active = object.is_active ?? false;
    message.is_restricted = object.is_restricted ?? false;
    message.allow_git_hook = object.allow_git_hook ?? false;
    message.prohibit_login = object.prohibit_login ?? false;
    message.two_fa_status = object.two_fa_status ?? false;
    message.login_source = object.login_source ?? 0;
    message.login_name = object.login_name ?? "";
    message.restricted = object.restricted ?? false;
    message.lower_name = object.lower_name ?? "";
    message.org_name = object.org_name ?? "";
    message.show_guide = object.show_guide ?? false;
    message.onboarding = object.onboarding ?? false;
    message.good_level = object.good_level ?? 0;
    message.end_time = object.end_time ?? "";
    message.max_seats = object.max_seats ?? 0;
    message.invited_org_id = object.invited_org_id ?? "";
    message.org_full_name = object.org_full_name ?? "";
    message.invitation_code = object.invitation_code ?? "";
    message.username = object.username ?? "";
    message.invitations =
      object.invitations?.map((e) => OrgUserInvitee.fromPartial(e)) || [];
    message.avatar = object.avatar ?? "";
    return message;
  },
};

export interface Auth {
  GetAuthenticatedUser(
    request: DeepPartial<Empty>,
    metadata?: grpc.Metadata
  ): Promise<AuthUser>;
}

export class AuthClientImpl implements Auth {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.GetAuthenticatedUser = this.GetAuthenticatedUser.bind(this);
  }

  GetAuthenticatedUser(
    request: DeepPartial<Empty>,
    metadata?: grpc.Metadata
  ): Promise<AuthUser> {
    return this.rpc.unary(
      AuthGetAuthenticatedUserDesc,
      Empty.fromPartial(request),
      metadata
    );
  }
}

export const AuthDesc = {
  serviceName: "api.v1.Auth",
};

export const AuthGetAuthenticatedUserDesc: UnaryMethodDefinitionish = {
  methodName: "GetAuthenticatedUser",
  service: AuthDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return Empty.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      return {
        ...AuthUser.decode(data),
        toObject() {
          return this;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR
  extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
    }
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata =
      metadata && this.options.metadata
        ? new BrowserHeaders({
            ...this.options?.metadata.headersMap,
            ...metadata?.headersMap,
          })
        : metadata || this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata,
        transport: this.options.transport,
        debug: this.options.debug,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message);
          } else {
            const err = new Error(response.statusMessage) as any;
            err.code = response.status;
            err.metadata = response.trailers;
            reject(err);
          }
        },
      });
    });
  }
}

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >;

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

// If you get a compile-error about 'Constructor<Long> and ... have no overlap',
// add '--ts_proto_opt=esModuleInterop=true' as a flag when calling 'protoc'.
if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
